// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_hh-0";
export var buttonContainer = "_hh-3";
export var cancelButton = "_hh-4";
export var headerSection = "_hh-6";
export var headerTitle = "_hh-9";
export var messageSideLeft = "_hh-1";
export var messageSideRight = "_hh-2";
export var orderNumberContainer = "_hh-7";
export var orderNumberLabel = "_hh-8";
export var submitButton = "_hh-5";